<template>
  <md-field :class="[
                {'md-error': errors.has('brandId')},
                {'md-valid': !errors.has('brandId') && touched.brandId}]" >
    <md-select
      v-model="brandId"
      data-vv-name="brandId"
      v-validate= "avoidValidFlag == true ? '' : modelValidations.brandId">
      <md-option v-for="item in listData" :value="item.id" :key="item.id">{{item.name}}</md-option>
    </md-select>
    <slide-y-up-transition>
      <div class="vErrorText" v-show="errors.has('brandId')">【必須】必ず一つ選択してください</div>
    </slide-y-up-transition>
    <slide-y-down-transition>
      <md-icon class="error" v-show="errors.has('brandId')" style="margin-right:20px">close</md-icon>
    </slide-y-down-transition>
    <slide-y-down-transition>
      <md-icon class="success" v-show="!errors.has('brandId') && touched.brandId" style="margin-right:20px">done</md-icon>
    </slide-y-down-transition>
  </md-field>
</template>
<script>
  import NestedValidator from '../../mixins/nested-validator'
  export default {
    inject: ['$validator'],
    mixins: [NestedValidator],
    data() {
      return {
        listData: [],
        modelValidations: {
          brandId: {
            required: true
          }
        },
        touched: {
          brandId: false,
        },
      }
    },
    model: {
    },
    props:  ['value','noSelectFlag','saveCondition','touchedFlag','avoidValidFlag'],    // undefinedはfalse扱い
    methods: {
      getBrands () {
        var condition = {
          company_id: (this.companyId==='選択しない' || this.companyId==null) ? '' : this.companyId
        }
        this.axios({
          method  : 'GET',
          url     : this.AdminApiUrl + '/brands/select_list',
          timeout : 10000,
          params: condition,
          headers : {'Authorization': this.$Cookies.get('accessToken')}
        }).then(response => {
          this.createList(response.data)
        })
        .catch(error => {
          this.dangerNotify('ブランドリストを取得できませんでした')
        })
      },
      createList (obj) {
        this.listData = []
        if (this.noSelectFlag) {
          var item = {
            id: '選択しない',
            name: '選択しない',
          }
          this.listData.push(item)
          if (!this.saveCondition) {
            this.companyId = '選択しない'
          }
        }
        for (var i in obj) {
          var item = {
            id: obj[i].id,
            name: obj[i].name
          }
          this.listData.push(item)
        }
      },
      setBrand () {
        var brandSelect = sessionStorage.getItem('brandSelect')
        if (brandSelect === null) {
          this.getBrands()
        } else {
          brandSelect = JSON.parse(brandSelect)
          this.createList(brandSelect)
        }
      },
      resetBrand () {
        sessionStorage.removeItem('brandSelect')
        this.setBrand()
      }
    },
    mounted () {
      this.setBrand()
      this.touched.brandId = false
    },watch: {
      brandId(){
        this.touched.brandId = this.touchedFlag
      },
      '$route.path'(value){
        if (value.match('new')) {
          this.$validator.reset()
          this.touched.brandId = false 
        }
      }
    },computed: {
      brandId: {
        get: function() {
          return this.value;
        },
        set: function(newValue) {
          this.$emit('input', newValue)
        }
      }
    }

  }
</script>
<style scoped>
.brandSelect{
  /* max-width: 120px; */
  width: 100%;
}
</style>